import {
  DefaultButton, mergeStyleSets, Stack,
} from '@fluentui/react';
import React from 'react';
import StackTokens from '../StackTokens';
import TextFieldBuffered from '../TextFieldBuffered';
import Theme from '../Theme';

const componentStylesRaw = {
  textFieldRoot: {
    wrapper: {
      marginTop: 'none !important',
    },
  },
};

const componentStyles = mergeStyleSets({
  button: {
    width: '34px',
    minWidth: 'auto',
    height: '32px',
    padding: '0',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '8px',
  },

  addButton: {
    marginTop: '21px',
  },
});

const trimValue = (value) => value.trim();

export default ({
  headerName = '',
  headerValue = '',
  add,
  apply,
  remove,
  onHeaderNameChange,
  onHeaderValueChange,
  nameError,
  valueError,
  onNameErrorClear,
  onValueErrorClear,
  onFieldErrorClear,
  stretch = false,
  className,
}) => {
  const isAddMode = typeof add === 'function';
  const isEditable = typeof apply === 'function' || isAddMode;
  const nameLabel = isAddMode ? 'Header' : '';
  const valueLabel = isAddMode ? 'Value' : '';

  const clearNameError = onNameErrorClear || onFieldErrorClear;
  const clearValueError = onValueErrorClear || onFieldErrorClear;

  const wrapField = (field) => (
    stretch
      ? <Stack.Item grow styles={{ root: { minWidth: 0 } }}>{field}</Stack.Item>
      : field
  );

  return (
    <Stack
      horizontal
      className={className}
      tokens={StackTokens.spacing}
      verticalAlign="start"
      styles={stretch ? { root: { width: '100%' } } : undefined}
    >
      {wrapField(
        <TextFieldBuffered
          label={nameLabel}
          editable={isEditable}
          actualValue={headerName}
          fieldError={nameError}
          onFieldErrorClear={clearNameError}
          validateValue={trimValue}
          applyValue={async (value) => {
            if (isAddMode) {
              onHeaderNameChange(value);
            } else {
              apply(value, headerValue);
            }
          }}
          styles={componentStylesRaw.textFieldRoot}
        />,
      )}

      {wrapField(
        <TextFieldBuffered
          label={valueLabel}
          editable={isEditable}
          actualValue={headerValue}
          fieldError={valueError}
          onFieldErrorClear={clearValueError}
          validateValue={trimValue}
          applyValue={async (value) => {
            if (isAddMode) {
              onHeaderValueChange(value);
            } else {
              apply(headerName, value);
            }
          }}
          styles={componentStylesRaw.textFieldRoot}
        />,
      )}

      <div>
        {isAddMode && (
          <DefaultButton
            text=""
            iconProps={{ iconName: 'Add' }}
            className={[
              Theme.styles.outlineControlButton,
              componentStyles.button,
              componentStyles.addButton,
            ].join(' ')}
            onClick={() => add(headerName, headerValue)}
            title="Add new header"
          />
        )}

        {typeof remove === 'function' && (
          <DefaultButton
            text=""
            iconProps={{ iconName: 'Delete' }}
            className={[Theme.styles.outlineControlButton, componentStyles.button].join(' ')}
            onClick={() => remove(headerName)}
            title="Delete header"
          />
        )}
      </div>
    </Stack>
  );
};
